import { render, staticRenderFns } from "./CourseCascader.vue?vue&type=template&id=4335bd1c&scoped=true"
import script from "./CourseCascader.vue?vue&type=script&lang=js"
export * from "./CourseCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4335bd1c",
  null
  
)

export default component.exports